import {
  Configuration,
  PublicClientApplication,
  SilentRequest,
  AuthenticationResult,
  EventMessage,
  EventType,
  RedirectRequest
} from "@azure/msal-browser";
import { client } from "./api";
import endpoints from "./endpoints";

class Auth {
  msalConfig: Configuration = {
    auth: {
      clientId: `${process.env.REACT_APP_CLIENT_ID}`,
      authority: `${process.env.REACT_APP_AUTHORITY}`,
      redirectUri: "/",
      postLogoutRedirectUri: "/logout"
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false
    }
  };

  loginRequest: RedirectRequest = {
    scopes: [`${process.env.REACT_APP_API_SCOPE}`],
    extraScopesToConsent: ["User.Read", "User.ReadBasic.All"]
  };

  msalInstance: PublicClientApplication;

  constructor() {
    this.msalInstance = new PublicClientApplication(this.msalConfig);

    this.msalInstance.enableAccountStorageEvents();
    this.msalInstance.addEventCallback((event: EventMessage) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const result: any = event.payload;
        client({
          url: endpoints.Me,
          params: { newLogin: true },
          headers: { Authorization: `Bearer ${result.accessToken}` }
        });
        const payload = event.payload as AuthenticationResult;
        this.msalInstance.setActiveAccount(payload.account);
      } else if (event.eventType === EventType.ACCOUNT_REMOVED) {
        window.location.href = "/logout";
      }
    });
  }

  async getToken(): Promise<AuthenticationResult> {
    let token = null;
    const activeAccount = this.msalInstance.getActiveAccount();
    const authRequest: SilentRequest = {
      scopes: [`${process.env.REACT_APP_API_SCOPE}`],
      account: activeAccount
    };

    try {
      token = await this.msalInstance.acquireTokenSilent(authRequest);
    } catch (e) {
      console.log("auth.ts - Exception for AcquireSilentToken", e);
      token = await this.msalInstance.acquireTokenRedirect(authRequest);
    }
    return token;
  }

  async getGraphToken(): Promise<AuthenticationResult> {
    let token = null;
    const activeAccount = this.msalInstance.getActiveAccount();
    const authRequest: SilentRequest = {
      scopes: ["User.Read", "User.ReadBasic.All"],
      account: activeAccount
    };

    try {
      token = await this.msalInstance.acquireTokenSilent(authRequest);
    } catch (e) {
      console.log("auth.ts - Exception for Graph AcquireSilentToken", e);
      token = await this.msalInstance.acquireTokenRedirect(authRequest);
    }
    return token;
  }

  async logout(): Promise<void> {
    const activeAccount = this.msalInstance.getActiveAccount();
    await this.msalInstance.logoutRedirect({
      account: activeAccount
    });
  }
}

const auth = new Auth();

export { Auth };
export default auth;
